import { createReducer, on } from "@ngrx/store";
import { addModal, removeModal } from "./actions";
import { IModalState } from "./model";

const initialState: Readonly<IModalState> = { modal: null, show: false };
export const modalReducer = createReducer(
  initialState,
  on(addModal, (state, { modal }) => ({ modal: modal, show: true })),
  on(removeModal, () => ({ modal: null, show: false })),
);